import { Components, Theme } from '@mui/material/styles';

export const MuiDivider: Components['MuiDivider'] = {
  styleOverrides: {
    root: (props) => {
      const theme = props.theme as Theme;
      return {
        borderColor: theme.palette.divider,
      };
    },
  },
};
